module.exports = __webpack_public_path__ + "static/img/8.d8543f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/zh/8.png
// module id = neGO
// module chunks = 0